export default {
    root: 'flex',
    controls: {
        class: [
            // Flexbox & Alignment
            'flex flex-col justify-center gap-2',

            // Spacing
            'p-5'
        ]
    },
    container: 'flex-auto'
};
